import { render, staticRenderFns } from "./qygl.vue?vue&type=template&id=d14fe9aa&scoped=true&"
import script from "./qygl.vue?vue&type=script&lang=js&"
export * from "./qygl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d14fe9aa",
  null
  
)

export default component.exports